import { gql } from '@apollo/client';

export const ITEM_DIMENSIONS_FIELDS = gql`
    fragment ItemDimensionsFields on item_dimensions {
        item_dimension_id
        client_id
        cubes
        sku
        length
        width
        height
        weight
        created_at
        last_modified_at
        service_time
        item_type_details
        assembly_type
        rate_class
    }
`;
